import React from 'react';
import { useStateMachine } from 'little-state-machine';
import updateAction from '../updateAction';

const IconCards = props => {
  return (
    <svg
      className="iconCards"
      width={31}
      height={31}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.751 29.411a.65.65 0 0 1-.273.547.69.69 0 0 1-.547.171c-1.413-.205-2.61-.854-3.59-1.948-.956-1.094-1.435-2.37-1.435-3.828V6.716c0-1.481.479-2.769 1.436-3.862C3.322 1.76 4.518 1.122 5.93.94a.562.562 0 0 1 .547.17.65.65 0 0 1 .273.547.656.656 0 0 1-.205.479.641.641 0 0 1-.41.24 4.328 4.328 0 0 0-1.333.41c-.41.204-.786.478-1.128.82-.433.41-.764.888-.991 1.435a4.463 4.463 0 0 0-.308 1.64v17.672c0 .57.103 1.128.308 1.675.227.524.558.99.99 1.401.343.342.719.627 1.129.854.41.205.854.33 1.333.376a.82.82 0 0 1 .41.274.656.656 0 0 1 .205.478ZM25.071.94c-.205-.046-.398.011-.58.17a.684.684 0 0 0-.24.547c0 .183.057.342.17.479a.782.782 0 0 0 .445.24c.479.068.923.204 1.333.41.41.204.786.478 1.128.82.433.41.752.888.957 1.435a4.07 4.07 0 0 1 .342 1.64v17.57c0 .592-.114 1.15-.342 1.674a3.851 3.851 0 0 1-.957 1.401 5.077 5.077 0 0 1-1.128.855 4.33 4.33 0 0 1-1.333.41.783.783 0 0 0-.444.24.725.725 0 0 0-.171.478c0 .205.08.376.24.512.182.16.375.228.58.206 1.413-.206 2.598-.855 3.555-1.949.98-1.093 1.47-2.37 1.47-3.828V6.716c0-1.481-.49-2.769-1.47-3.862-.957-1.094-2.142-1.732-3.555-1.914Zm-.82 24.78h-7.28c-.41 0-.764-.137-1.06-.41a1.51 1.51 0 0 1-.41-1.06V6.75c0-.41.137-.752.41-1.025.296-.296.65-.444 1.06-.444h7.28c.41 0 .752.148 1.025.444.297.273.445.615.445 1.025v17.5c0 .41-.148.764-.445 1.06-.273.273-.615.41-1.025.41Zm0-1.47V6.75h-7.28v17.5h7.28Zm-10.22-2.837v-3.52l-3.691-8.1 3.691-1.71V6.614c0-.046.012-.092.034-.137l-4.34 2.016c-.365.16-.627.433-.787.82-.136.365-.113.73.069 1.095l5.024 11.005Zm-7.28-.341 2.46-6.665-.649-1.436a1.765 1.765 0 0 0-.375.342c-.114.114-.206.25-.274.41l-2.53 6.836c-.136.387-.125.763.035 1.128.182.364.456.615.82.752l8.067 3.008-.889-1.88-6.665-2.495Z"
        fill="#FF6200"
      />

      <style jsx>{`
        .iconCards {
          position: absolute;
          transform: translate(-170%, 3px);
        }
      `}</style>
    </svg>
  );
};

const ProtectCard = () => {
  const { action, state } = useStateMachine(updateAction);

  return (
    <div id="protect-card">
      <p className="title">Asegurá y protegé tu tarjeta</p>
      <label className="wrapper" htmlFor="protectCard">
        <div>
          <input
            type="checkbox"
            name="protectCard"
            id="protectCard"
            defaultChecked={state.data.contrataSeguroFraudes}
            onChange={e => action({ contrataSeguroFraudes: e.target.checked })}
          />
          <span className="customCheckbox"></span>
          <IconCards />
          Quiero proteger mi tarjeta con el Seguro de Protección Total de MAPFRE, a $335 por mes.
        </div>
        <a href="https://www.itau.com.uy/inst/seguroFinanzas.html" target="_blank">
          Conocé más
        </a>
      </label>

      <style jsx>{`
        #protect-card .title {
          color: #000;
          font-weight: 700;
          margin: 40px 0 10px;
        }

        #protect-card label {
          background-color: white;
          border-radius: 4px;
          border-left: 4px solid #ff6200;
          display: flex;
          flex-direction: column;
          gap: 14px;
          align-items: flex-start;
          padding: 24px 24px 24px 115px;
          margin-bottom: 40px;
          box-shadow: 0px 0px 15px rgba(16, 25, 32, 0.05), 0px 2px 15px rgba(6, 21, 33, 0.05);
          position: relative;
          color: #56504c;
          cursor: pointer;
        }

        #protect-card label input[type='checkbox'] {
          position: absolute;
          opacity: 0;
          left: 24px;
          transform: translateY(5px);
        }

        #protect-card .customCheckbox {
          content: '';
          margin-right: 10px;
          display: inline-block;
          vertical-align: text-top;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          border: 2px solid #dcdcdc;
          background-color: white;
          position: absolute;
          left: 0;
          transform: translate(25px, 5px);
        }

        #protect-card label input[type='checkbox']:checked + .customCheckbox {
          border-color: #ff6200;
          background-image: radial-gradient(circle at center, #ff6200 40%, white 40%);
        }

        #protect-card label a {
          display: block;
          color: #007ab7;
          text-decoration: none;
        }
      `}</style>
    </div>
  );
};

export default ProtectCard;
